module.exports = __webpack_public_path__ + "static/blue_sapphire-957b1270bb40fbf29af4f66ecd1cf328.svg";